export default __webpack_public_path__ + "static/media/74889b0bb8947f062a7d37667047cc9e.jpg";